import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "../../../../shared/utilities/graphql/apolloClient";
import ListingNote from "../ListingNote";

const App = props => (
  <ApolloProvider client={apolloClient}>
    <ListingNote {...props} />
  </ApolloProvider>
);

export default App;
